const rooturl = "https://www.globe-zoom.com"
// const rooturl ="http://localhost"
export const fetchrootpath = `${rooturl}/fetch`
// https://www.globe-zoom.com/fetch/searchvillage?searchstr=akola,agar
export const authrootpath =  `${rooturl}:4080`

// export const authrootpath =  `${rooturl}/post`  // production
// export const postrootpath =  `${rooturl}:4040/post` // development
export const postrootpath =  `${rooturl}/post` // production
// export const tilerootpath =  `${rooturl}:5030/tiles`
export const tilerootpath =  `${rooturl}/tiles`//production





// https://en-in.topographic-map.com/?_path=api.maps.getOverlay&southLatitude=15.241527777777778&westLongitude=72.31180555555557&northLatitude=26.431527777777777&eastLongitude=85.36402777777778&zoom=6&version=202212181116